import { render, staticRenderFns } from "./OnboardingAccount.vue?vue&type=template&id=24e92ad2&"
import script from "./OnboardingAccount.vue?vue&type=script&lang=js&"
export * from "./OnboardingAccount.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports